import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {StringUtil} from '../../global/util/StringUtil';
import {Document} from '../model/Document';
import {Constant} from '../../global/util/Constant';

@Injectable({
  providedIn: 'root'
})
export class UanatacaService {

  constructor(private http: HttpClient) {
  }

  public post(url: string, documents: Document[]): Observable<any> {
    const formData = new FormData();
    if (documents !== null) {
      const docIdentifiers = StringUtil.concatIdentifiers(documents);
      formData.append('docIdentifiers', docIdentifiers);
    }
    return this.http.post(url, formData);
  }

  public post1(url: string, formData: FormData): Observable<any> {
    return this.http.post(url, formData);
  }

  public get(url: string): Observable<any> {
    return this.http.get(url, {responseType: 'blob'});
  }

  public search(personId: number, user: string) {
    const url = Constant.ROOT_API_V1
      .concat('/public/')
      .concat('people/')
      .concat(String(personId))
      .concat('?findby=').concat(user);
    return this.http.get(url);
  }
}
